import clearShortcuts from './clearShortcuts'

export default function(o){

  o.body.off('touchstart mousemove')

  clearShortcuts()

  var view = o.getView()

  o.viewDiv
  .css({
    pointerEvents: 'none',
  })

  var loadingLabel =
    o.util.getTranslation(o, 'loading')

  var loadingButton =
    o.component.button(o,loadingLabel,function(){location.reload()})
    .css({
      fontSize: o.fontSizeDef.s
    })
    .hide()

  var loadingDiv =
    $('<div>')
    .addClass('loadingDiv')
    .css({
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: 1,
    })
    .append(
      loadingButton,
    )

  setTimeout(function(){
    loadingButton.show()
  }, 3000)

  o.body.append(loadingDiv)
  o.viewDiv.hide()

  if(view != 'tag'){
    o.util.soundStop(o)
  }

  var transition = function(div){

    div
    .hide()
    .show()
    
    o.viewDiv.remove()
    loadingDiv.remove()
    o.viewDiv = div

    requestAnimationFrame(function(){
      o.iphoneNavbarFix()
    })

    o.log('page', location.pathname)

    o.body
    .append(
      div
    )

  }

  var startTime = new Date()

  o.view[view](o, function(div){

    var timePassed = new Date() - startTime

    if(timePassed < 500){
      var diff = 500 - timePassed
      setTimeout(function(){
        transition(div)
      }, diff)
    } else {
      transition(div)
    }

  })

}



// WEBPACK FOOTER //
// ./src/client/view/frontend/app/render.js